(() => {
  const initialize = () => {
    document.querySelectorAll('.ba-preview-header__buy').forEach((button) => {
      button.addEventListener('click', (event) => {
        const href = button.getAttribute('href');
        if (!href || !href.startsWith('#')) return;
        const target =
          document.querySelector(href) ||
          document.querySelector('basic-preset-builder, basic-bundle-builder, variant-selects, product-form, .product-form, [id^="ProductInfo-"]');
        if (!target) return;

        event.preventDefault();
        const menu = button.closest('.ba-preview-header')?.querySelector('.ba-preview-header__menu');
        if (menu) menu.open = false;

        window.requestAnimationFrame(() => {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (target.id && history.replaceState) history.replaceState(null, '', `#${target.id}`);
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
